<template>
  <div class="row">
    <div class="col-6">
      <label for="selectedReportType" class="form-text">نوع گزارش</label>
      <vue-select id="selectedReportType" v-model="selectedReportType" :options="reportTypes" dir="rtl" label="value" :clearable="false">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label v-if="selectedReportType?.key == 1" for="searchString" class="form-text">کد / عنوان / توضیح اولیه</label>
      <input v-if="selectedReportType?.key == 1" id="searchString" class="form-control" type="text" v-model.trim="searchString" />
    </div>
    <div class="col-6">
      <label for="companySections" class="form-text">بخش هدف</label>
      <vue-select id="companySections" v-model="selectedCompanySections" :options="companySections" dir="rtl" label="title" multiple
        @click="getCompanySections()">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label for="selectedTicketImportances" class="form-text">اهمیت</label>
      <vue-select id="selectedTicketImportances" v-model="selectedTicketImportances" :options="ticketImportances"
        dir="rtl" label="value" multiple>
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label v-if="selectedReportType?.key == 1" for="selectedTicketLabels" class="form-text">برچسب‌ها</label>
      <vue-select v-if="selectedReportType?.key == 1" id="selectedTicketLabels" v-model="selectedTicketLabels" :options="ticketLabels"
        dir="rtl" label="title" multiple @click="getTicketLabels()">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label for="ticketStatuses" class="form-text">وضعیت</label>
      <vue-select id="ticketStatuses" v-model="selectedTicketStatuses" :options="ticketStatuses" dir="rtl" label="value" multiple>
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label for="customerId" class="form-text">مشتری</label>
      <treeselect id="customerId" :key="'tLCustomerTreeselect' + treeselectKey" v-model="customerId" :multiple="false"
        :placeholder="'انتخاب مشتری'" :showCount="true" noOptionsText="هنوز مشتری‌ای تعریف نشده است"
        noResultsText="موردی یافت نشد" noChildrenText="این مشتری فاقد زیر مجموعه است"
        :options="customers" />
    </div>
    <div class="col-6">
      <label for="customerUsers" class="form-text">کاربر مشتری</label>
      <vue-select id="customerUsers" v-model="selectedUsers" :options="customerUsers" dir="rtl" label="displayProp" multiple
        @click="getUsersByCustomer()">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-sm-6">
      <label for="createDateFrom" class="form-text">تاریخ ایجاد از</label>
      <date-picker id="createDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="createDateFrom" clearable editable />
    </div>
    <div class="col-sm-6">
      <label for="createDateTo" class="form-text">تاریخ ایجاد تا</label>
      <date-picker id="createDateTo" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="createDateTo" clearable editable />
    </div>
    <div class="col-sm-6">
      <label for="answeredDateFrom" class="form-text">تاریخ پاسخ به تیکت از</label>
      <date-picker id="answeredDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="answeredDateFrom" clearable editable />
    </div>
    <div class="col-sm-6">
      <label for="answeredDateTo" class="form-text">تاریخ پاسخ به تیکت تا</label>
      <date-picker id="answeredDateTo" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="answeredDateTo" clearable editable />
    </div>
    <div class="col-6">
      <label for="referringUser" class="form-text">کاربر ارجاع دهنده</label>
      <vue-select id="referringUser" v-model="referringUser" :options="companyUsers" dir="rtl" label="displayProp"
        @click="getUsersByCompany()">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label v-if="selectedReportType?.key == 1 || selectedReportType?.key == 9"
        for="directlyReferredToUser" class="form-text">کاربر هدف مستقیم ارجاع</label>
      <vue-select v-if="selectedReportType?.key == 1 || selectedReportType?.key == 9" @click="getUsersByCompany()"
        id="directlyReferredToUser" v-model="directlyReferredToUser" :options="companyUsers" dir="rtl" label="displayProp">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-sm-6">
      <label for="referDateFrom" class="form-text">تاریخ ارجاع تیکت از</label>
      <date-picker id="referDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="referDateFrom" clearable editable />
    </div>
    <div class="col-sm-6">
      <label for="referDateTo" class="form-text">تاریخ ارجاع تیکت تا</label>
      <date-picker id="referDateTo" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
        v-model="referDateTo" clearable editable />
    </div>
    <div class="col-6">
      <label for="timeSpentFrom" class="form-text">مجموع زمان صرف شده از</label>
      <input id="timeSpentFrom" class="form-control" type="text"
        v-model.trim="timeSpentFrom.inputValue.value"
        @blur="timeSpentFrom.applyFormat"
        @keyup.enter.prevent="timeSpentFrom.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeSpentTo" class="form-text">مجموع زمان صرف شده تا</label>
      <input id="timeSpentTo" class="form-control" type="text"
        v-model.trim="timeSpentTo.inputValue.value"
        @blur="timeSpentTo.applyFormat"
        @keyup.enter.prevent="timeSpentTo.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeBeforeFirstChangeByCompanyFrom" class="form-text">زمان گذشته تا اولین تغییر توسط شرکت از</label>
      <input id="timeBeforeFirstChangeByCompanyFrom" class="form-control" type="text"
        v-model.trim="timeBeforeFirstChangeByCompanyFrom.inputValue.value"
        @blur="timeBeforeFirstChangeByCompanyFrom.applyFormat"
        @keyup.enter.prevent="timeBeforeFirstChangeByCompanyFrom.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeBeforeFirstChangeByCompanyTo" class="form-text">زمان گذشته تا اولین تغییر توسط شرکت تا</label>
      <input id="timeBeforeFirstChangeByCompanyTo" class="form-control" type="text"
        v-model.trim="timeBeforeFirstChangeByCompanyTo.inputValue.value"
        @blur="timeBeforeFirstChangeByCompanyTo.applyFormat"
        @keyup.enter.prevent="timeBeforeFirstChangeByCompanyTo.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeAwaitingCustomerAnswerFrom" class="form-text">زمان در انتظار پاسخ مشتری از</label>
      <input id="timeAwaitingCustomerAnswerFrom" class="form-control" type="text"
        v-model.trim="timeAwaitingCustomerAnswerFrom.inputValue.value"
        @blur="timeAwaitingCustomerAnswerFrom.applyFormat"
        @keyup.enter.prevent="timeAwaitingCustomerAnswerFrom.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeAwaitingCustomerAnswerTo" class="form-text">زمان در انتظار پاسخ مشتری تا</label>
      <input id="timeAwaitingCustomerAnswerTo" class="form-control" type="text"
        v-model.trim="timeAwaitingCustomerAnswerTo.inputValue.value"
        @blur="timeAwaitingCustomerAnswerTo.applyFormat"
        @keyup.enter.prevent="timeAwaitingCustomerAnswerTo.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeTakenToAnswerFrom" class="form-text">زمان طی شده تا پاسخ به تیکت از</label>
      <input id="timeTakenToAnswerFrom" class="form-control" type="text"
        v-model.trim="timeTakenToAnswerFrom.inputValue.value"
        @blur="timeTakenToAnswerFrom.applyFormat"
        @keyup.enter.prevent="timeTakenToAnswerFrom.applyFormat" />
    </div>
    <div class="col-6">
      <label for="timeTakenToAnswerTo" class="form-text">زمان طی شده تا پاسخ به تیکت تا</label>
      <input id="timeTakenToAnswerTo" class="form-control" type="text"
        v-model.trim="timeTakenToAnswerTo.inputValue.value"
        @blur="timeTakenToAnswerTo.applyFormat"
        @keyup.enter.prevent="timeTakenToAnswerTo.applyFormat" />
    </div>
    <div class="col-6">
      <label v-if="selectedReportType?.key == 1" for="selectedSorting" class="form-text">ترتیب نمایش</label>
      <vue-select v-if="selectedReportType?.key == 1"
        id="selectedSorting" v-model="selectedSorting" :options="sortOptions" dir="rtl" label="value" :clearable="false">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div class="col-6">
      <label for="selectedPageSize" class="form-text">تعداد در هر صفحه</label>
      <vue-select id="selectedPageSize" v-model="selectedPageSize" :options="pageSizes" dir="rtl" label="value" :clearable="false">
        <template #no-options="{ search, searching, loading }">موردی یافت نشد!</template>
      </vue-select>
    </div>
    <div>
      <button class="btn btn-sm col-lg-2 col-md-3 col-5 mt-3 me-3 mb-0 bg-gradient-primary" @click="setFilters">
        دریافت گزارش
      </button>
      <button class="btn btn-sm col-lg-2 col-md-3 col-5 mt-3 me-3 mb-0 bg-gradient-warning" @click="clearFilters">
        خالی کردن فیلترها
      </button>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service';
import UserService from '../../../services/User/User-service';
import LabelService from '../../../services/Ticket/LabelService';

import Treeselect from '@cholakovdev/vue3-treeselect';
import PersianDateTime from "vue3-persian-datetime-picker";
import { useDurationFormatter } from '../../../composables/utility/UseDurationFormatter';

export default {
  components: { Treeselect, PersianDateTime },
  emits: ["filtersConfirmed"],
  props: {
    selectedSortingProp: {
      type: Object
    },
    pageSizeProp: {
      type: Number
    }
  },
  setup() {
    let timeAwaitingCustomerAnswerFrom = useDurationFormatter();
    let timeAwaitingCustomerAnswerTo = useDurationFormatter();
    let timeSpentFrom = useDurationFormatter();
    let timeSpentTo = useDurationFormatter();
    let timeBeforeFirstChangeByCompanyFrom = useDurationFormatter();
    let timeBeforeFirstChangeByCompanyTo = useDurationFormatter();
    let timeTakenToAnswerFrom = useDurationFormatter();
    let timeTakenToAnswerTo = useDurationFormatter();

    return {
      timeAwaitingCustomerAnswerFrom,
      timeAwaitingCustomerAnswerTo,
      timeSpentFrom,
      timeSpentTo,
      timeBeforeFirstChangeByCompanyFrom,
      timeBeforeFirstChangeByCompanyTo,
      timeTakenToAnswerFrom,
      timeTakenToAnswerTo
    }
  },
  data() {
    return {
      treeselectKey: 0,
      companyId: null,
      reportTypes: [
        { key: 1, value: 'تیکت' },
        { key: 5, value: 'کارشناس' },
        { key: 9, value: 'مشتری' },
      ],
      selectedReportType: { key: 1, value: 'تیکت' },
      pageSizes: [10, 15, 20, 30, 50, 100],
      selectedPageSize: 20,
      sortOptions: [
        { key: 0, value: 'قدیمی ترین تیکت' },
        { key: 1, value: 'جدیدترین تیکت' },
      ],
      selectedSorting: { key: 1, value: 'جدیدترین تیکت' },
      ticketStatuses: [
        { key: 0, value: 'دیده نشده' },
        { key: 2, value: 'درحال بررسی' },
        { key: 7, value: 'در انتظار پاسخ مشتری'},
        { key: 3, value: 'پاسخ داده شده' },
        { key: 4, value: 'بسته شده توسط کارشناس' },
        { key: 5, value: 'بسته شده توسط کاربر' },
        { key: 6, value: 'بسته شده توسط سیستم' },
      ],
      selectedTicketStatuses: [],
      ticketImportances: [
        { key: 0, value: 'پایین' },
        { key: 1, value: 'متوسط' },
        { key: 2, value: 'بالا' },
      ],
      selectedTicketImportances: [],
      companySections: [],
      selectedCompanySections: [],
      customers: [],
      customerId: null,
      customerUsers: [],
      selectedUsers: [],
      companyUsers: [],
      referringUser: null,
      directlyReferredToUser: null,
      ticketLabels: [],
      selectedTicketLabels: [],
      searchString: null,
      createDateFrom: null,
      createDateTo: null,
      answeredDateFrom: null,
      answeredDateTo: null,
      referDateFrom: null,
      referDateTo: null,
    }
  },
  watch: {
    customerId(s) {
      this.customerUsers = [];
      this.selectedUsers = [];
    },
    selectedSortingProp(sorting) {
      this.selectedSorting = sorting ?? { key: 1, value: 'جدیدترین تیکت' };
    },
    pageSizeProp(pageSize) {
      this.selectedPageSize = pageSize ?? 20;
    }
  },
  methods: {
    setFilters() {
      let filters = {
        selectedReportType: this.selectedReportType,
        selectedTicketStatuses: this.selectedTicketStatuses ?? [],
        selectedTicketImportances: this.selectedTicketImportances ?? [],
        selectedCompanySections: this.selectedCompanySections ?? [],
        customerId: this.customerId,
        selectedUsers: this.selectedUsers ?? [],
        referringUser: this.referringUser,
        directlyReferredToUser: this.directlyReferredToUser,
        selectedTicketLabels: this.selectedTicketLabels ?? [],
        searchString: this.searchString,
        createDateFrom: this.createDateFrom,
        createDateTo: this.createDateTo,
        answeredDateFrom: this.answeredDateFrom,
        answeredDateTo: this.answeredDateTo,
        referDateFrom: this.referDateFrom,
        referDateTo: this.referDateTo,
        timeAwaitingCustomerAnswerFrom: this.timeAwaitingCustomerAnswerFrom.totalMinutes.value,
        timeAwaitingCustomerAnswerTo: this.timeAwaitingCustomerAnswerTo.totalMinutes.value,
        timeSpentFrom: this.timeSpentFrom.totalMinutes.value,
        timeSpentTo: this.timeSpentTo.totalMinutes.value,
        timeBeforeFirstChangeByCompanyFrom: this.timeBeforeFirstChangeByCompanyFrom.totalMinutes.value,
        timeBeforeFirstChangeByCompanyTo: this.timeBeforeFirstChangeByCompanyTo.totalMinutes.value,
        timeTakenToAnswerFrom: this.timeTakenToAnswerFrom.totalMinutes.value,
        timeTakenToAnswerTo: this.timeTakenToAnswerTo.totalMinutes.value,
        selectedSorting: this.selectedSorting,
        pageIndex: 0,
        pageSize: this.selectedPageSize,
      };

      this.$emit("filtersConfirmed", filters);
    },
    clearFilters() {
      this.selectedTicketStatuses = [];
      this.selectedTicketImportances = [];
      this.selectedCompanySections = [];
      this.customerId = null;
      this.selectedUsers = [];
      this.referringUser = null;
      this.directlyReferredToUser = null;
      this.selectedTicketLabels = [];
      this.searchString = null;
      this.createDateFrom = null;
      this.createDateTo = null;
      this.answeredDateFrom = null;
      this.answeredDateTo = null;
      this.referDateFrom = null;
      this.referDateTo = null;
      this.timeAwaitingCustomerAnswerFrom.emptyValue();
      this.timeAwaitingCustomerAnswerTo.emptyValue();
      this.timeSpentFrom.emptyValue();
      this.timeSpentTo.emptyValue();
      this.timeBeforeFirstChangeByCompanyFrom.emptyValue();
      this.timeBeforeFirstChangeByCompanyTo.emptyValue();
      this.timeTakenToAnswerFrom.emptyValue();
      this.timeTakenToAnswerTo.emptyValue();
      this.selectedSorting = { key: 1, value: 'جدیدترین تیکت' };
      this.selectedPageSize = 20;

      this.treeselectKey++;
    },
    getCompanySections() {
      if (this.companySections?.length > 0)
        return;

      CompanyService.getSectionsForReferringByCompanyId(this.companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.companySections = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUsersByCustomer() {
      if (!this.customerId | this.customerUsers?.length > 0)
        return;

      UserService.getListByCustomerId(this.customerId).then(response => {
        let result = response.data;

        if (result.success) {
          this.customerUsers =
            result.data.map(user => ({ ...user, displayProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUsersByCompany() {
      if (this.companyUsers?.length > 0)
        return;

      UserService.getListByCompanyId(this.companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.companyUsers =
            result.data.map(user => ({ ...user, displayProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getTicketLabels() {
      if (this.ticketLabels?.length > 0)
        return;

      LabelService.listCompanyLabels(false).then(response => {
        let result = response.data;

        if (result.success)
          this.ticketLabels = result.data;
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    setFiltersFromStore() {
      let filters = this.$store.getters.getComprehensiveReportFilters;

      this.selectedReportType = filters.selectedReportType ?? { key: 1, value: 'تیکت' };
      this.selectedTicketStatuses = filters.selectedTicketStatuses;
      this.selectedTicketImportances = filters.selectedTicketImportances;
      this.selectedCompanySections = filters.selectedCompanySections;
      this.customerId = filters.customerId;
      this.selectedUsers = filters.selectedUsers;
      this.referringUser = filters.referringUser;
      this.directlyReferredToUser = filters.directlyReferredToUser;
      this.selectedTicketLabels = filters.selectedTicketLabels;
      this.searchString = filters.searchString;
      this.createDateFrom = filters.createDateFrom;
      this.createDateTo = filters.createDateTo;
      this.answeredDateFrom = filters.answeredDateFrom;
      this.answeredDateTo = filters.answeredDateTo;
      this.referDateFrom = filters.referDateFrom;
      this.referDateTo = filters.referDateTo;
      this.timeAwaitingCustomerAnswerFrom.takeMinuteValue(filters.timeAwaitingCustomerAnswerFrom);
      this.timeAwaitingCustomerAnswerTo.takeMinuteValue(filters.timeAwaitingCustomerAnswerTo);
      this.timeSpentFrom.takeMinuteValue(filters.timeSpentFrom);
      this.timeSpentTo.takeMinuteValue(filters.timeSpentTo);
      this.timeBeforeFirstChangeByCompanyFrom.takeMinuteValue(filters.timeBeforeFirstChangeByCompanyFrom);
      this.timeBeforeFirstChangeByCompanyTo.takeMinuteValue(filters.timeAwaitingCustomerAnswerTo);
      this.timeTakenToAnswerFrom.takeMinuteValue(filters.timeTakenToAnswerFrom);
      this.timeTakenToAnswerTo.takeMinuteValue(filters.timeTakenToAnswerTo);
      this.selectedSorting = filters.selectedSorting ?? { key: 1, value: 'جدیدترین تیکت' };
      this.selectedPageSize = filters.pageSize ?? 20;
    }
  },
  mounted() {
    this.companyId = this.$store.state.currentUserInfo.companyId;
    this.customers = this.$store.state.currentUserInfo.customers;
    
    this.setFiltersFromStore();
  },
}
</script>